<div *ngIf="!protectedMode || (_conversationItems$ | async).length > 0"
	placement="bottom" autoClose="outside" class="kt-header__topbar-item"
	(click)='openDialogWithTemplateRef(dialog)'>
	<div class="kt-header__topbar-wrapper">
		<span class="kt-header__topbar-icon kt-pulse kt-pulse--brand">
			<span class="kt-pulse__ring" [hidden]="!newMessages"></span>
			<i [ngClass]="icon"
			   [matBadge]="(_conversationItems$ | async).length > 0? (_conversationItems$ | async).length : null "></i>
		</span>
	</div>

	<ng-template #dialog>
	<div >
		<form style="border-bottom: solid 1px #DEDEDE;">
			<!--begin: Head -->
			<div class="kt-head kt-head--skin-dark kt-head--fit-x kt-head--fit-b notification-header" [ngStyle]="{'background-image': backGroundStyle() }">
				<h3 class="kt-head__title">
					{{'SYSTEM.CONVERSATION.TITLE' | translate}}
				</h3>
				<div *ngIf="newMessages" style="width: 100%; text-align: center; margin-top: 1em;">
					<div class="btn btn-{{ type }} btn-sm btn-bold btn-font-md">
						{{'SYSTEM.CONVERSATION.NEW_MESSAGES' | translate | stringFormat: newMessageCount}}
					</div>
				</div>
			</div>
			<!--end: Head -->

			<div [perfectScrollbar]="{wheelPropagation: false}" [ngStyle]="{'max-height': '40vh', 'position': 'relative', 'overflow-y': 'scroll'}" class="kt-notification kt-margin-t-10 kt-margin-b-10">
					<div *ngFor="let item of (_conversationItems$ | async);"
						class="kt-notification__item conversation-mgr-item">
						<!-- opcion para eleminar mensaje -->
						<div *ngIf="item.canBeDeleted"
							(click)="deleteMessage(item)"
							class="kt-notification__item-icon">
							<i
								class="flaticon-delete-1 kt-font-success"
								[matTooltip]="'SYSTEM.CONVERSATION.TOOLTIP.DELETE' | translate"></i>
						</div>

						<div *ngIf="!item.canBeDeleted"
							class="kt-notification__item-icon">
							<i
								*ngIf="currentUserId != item.userId"
								class="flaticon2-rectangular kt-font-success"
								[matTooltip]="'SYSTEM.CONVERSATION.TOOLTIP.RECEIVED' | translate"></i>
							<i
								*ngIf="currentUserId == item.userId"
								class="flaticon2-paperplane kt-font-success"
								[matTooltip]="'SYSTEM.CONVERSATION.TOOLTIP.SENT' | translate"></i>
						</div>
						<div class="kt-notification__item-details">
							<div class="kt-notification__item-title">
								{{item.message}}
							</div>
							<div class="kt-notification__item-time">
								{{ item.createDate | date: 'dd/MM/yyyy HH:mm' }}
							</div>
						</div>
					</div>
					<div
						*ngIf="(_conversationItems$ | async).length == 0"
						class="kt-notification__item">
						<div class="kt-notification__item-icon">
							<i class="flaticon2-exclamation kt-font-success"></i>
						</div>
						<div class="kt-notification__item-details">
							<div class="kt-notification__item-title">
								{{'SYSTEM.CONVERSATION.NO_MESSAGE' | translate}}
							</div>
						</div>
					</div>
					<div class="ps__rail-y" style="top: 0px; right: 0px;">
						<div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
					</div>
			</div>
		</form>
		<!-- Texto Mensaje -->
		<div *ngIf="!protectedMode">
			<div class="row send-msg-field">
				<div class="col-lg-10">
					<mat-form-field class="mat-form-field-fluid">
						<input matInput
						#textInput
						>
						<mat-hint align="end">{{textInput.value.length}} / {{255}}</mat-hint>
						<!-- errors -->
						<!-- <mat-hint *ngIf="evaluationFormGroup.get(evaluationFormControlName).errors?.required">Campo Requerido</mat-hint>
						<mat-hint *ngIf="evaluationFormGroup.get(evaluationFormControlName).errors?.maxlength">Largo máximo {{maxLength}} caracteres</mat-hint>
						-->
					</mat-form-field>
				</div>
				<label class="col-lg-2 col-form-label send-button">
					<button [matTooltip]="'SYSTEM.CONVERSATION.TOOLTIP.SEND' | translate"
						mat-icon-button
						color="primary"
						class="large send-button-fix"
						(click)="enqueueMessage(textInput.value); textInput.value=null"
						[disabled]="textInput.value.length == 0">
						<i class="material-icons">send</i>
					</button>
				</label>
			</div>
		</div>
	</div>
	</ng-template>

</div>
